module.exports = __webpack_public_path__ + "img/villa_management_service.641f5e77.jpg";